import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from './auth.service';

/**
 * Solo deja pasar a usuarios que gestionan usuarios y sesiones: rol ADMIN u OWNER (`isAdmin`).
 *
 * Se usa después de authGuard: si los roles aún no están cargados
 * (recarga de página), consulta /auth/me antes de decidir.
 * @param _route - Ruta destino; no se usa.
 * @param _state - Estado del router; no se usa.
 * @returns `true` si es ADMIN u OWNER, o un `UrlTree` a la raíz si no lo es o si `/auth/me` falla
 *   (directo o como Observable cuando hay que consultar los roles).
 */
export const adminGuard: CanActivateFn = (_route, _state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (authService.roles().length > 0) {
        return authService.isAdmin() || router.createUrlTree(['/']);
    }

    return authService.me().pipe(
        map(() => authService.isAdmin() || router.createUrlTree(['/'])),
        catchError(() => of(router.createUrlTree(['/'])))
    );
};
